import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

//STYLES
import { SidebarContainerFullscreen, SidebarContent, SidebarFooter, SidebarTopBar } from "./styled";

//APP
import { LabAnaliseItens } from "../../../../../../../../../../../../../../../../services/LabAnalise";
import { PropsAnalisesCadastradas } from "../../../../../../../../types";
import { GeoPointFeature } from "../..";

//COMPONENTS
import ButtonCustom from "../../../../../../../../../../../../../../../../Components/ButtonCustom";
import { ControleLateralModal } from "../controleLateralModal";
import { InfosMalha } from "../infosMalha";
import { AlteracoesMalha } from "../alteracoesMalha";
import { AcaoSalvar } from "../acaoSalvar";

interface Props {
    toggleFullscreen: Function;
    inserirPontos: boolean;
    moverPontos: boolean;
    /** Área do talhão em hectares, já calculada pelo pai. */
    talhao_area: number;
    pontos: GeoPointFeature[];
    /** Pontos da malha que ainda não pertencem a nenhuma análise. */
    pontos_nunca_usados: number;
    setInserirPontos: React.Dispatch<React.SetStateAction<boolean>>;
    setMoverPontos: React.Dispatch<React.SetStateAction<boolean>>;
    tipo_analise_selecionada: string;
    setTipo_analise_selecionada: React.Dispatch<React.SetStateAction<string>>;
    setTipo_analise_selecionada_id: React.Dispatch<React.SetStateAction<number>>;
    pontos_selecionados: GeoPointFeature[];
    selecionarTodos: boolean;
    pontos_selecionados_adicionados: PropsAnalisesCadastradas[];
    cor: string;
    setCor: React.Dispatch<React.SetStateAction<string>>;
    fake_loading: boolean;
    grupoAnalises: LabAnaliseItens[];
    grupoAnalisesTratado: any[];
    salvarPontosSelecionados: Function;
    adicionarPontosSelecionados: Function;
    selecionarTodosPontos: Function;
    limparPontosSelecionados: Function;
    deletarPontosSelecionados: Function;
    /** Análises já salvas no formulário, usadas só para leitura na seleção em massa. */
    analises_salvas?: any[];
    selecionarPontosEmMassa: (pontos: GeoPointFeature[]) => void;
    inverterSelecaoPontos: () => void;
    /** Cods de análise já usados na OS — desabilitados no select. */
    analises_em_uso?: number[];
    /** Id da análise com pontos destacados no mapa (botão do olho). */
    analise_destacada?: string | number | null;
    aoDestacarAnalise?: (item: any) => void;
}

/**
 * Sidebar exibida sobre o mapa em tela cheia.
 *
 * É só o layout: infos, switchers, controle lateral e salvar vêm dos mesmos componentes
 * usados fora do fullscreen — aqui apenas o container muda.
 */
export const CardFullscreen: React.FC<Props> = ({ toggleFullscreen, inserirPontos, talhao_area, grupoAnalises,
    grupoAnalisesTratado, moverPontos, pontos, pontos_nunca_usados, cor, setCor, fake_loading, setInserirPontos,
    setMoverPontos, tipo_analise_selecionada, setTipo_analise_selecionada, setTipo_analise_selecionada_id,
    pontos_selecionados, selecionarTodos, pontos_selecionados_adicionados, salvarPontosSelecionados,
    adicionarPontosSelecionados, selecionarTodosPontos, limparPontosSelecionados, deletarPontosSelecionados,
    analises_salvas = [], selecionarPontosEmMassa, inverterSelecaoPontos, analises_em_uso = [], analise_destacada = null, aoDestacarAnalise
}) => {

    return (
        <SidebarContainerFullscreen>
            <SidebarTopBar>
                <ButtonCustom
                    type="tertiary"
                    danger
                    onClick={() => toggleFullscreen()}
                    icon={<FontAwesomeIcon icon={faArrowLeft} />}
                >
                    Voltar
                </ButtonCustom>
            </SidebarTopBar>

            {/* Header: Informações */}
            <InfosMalha
                variante="sidebar"
                talhao_area={talhao_area}
                total_pontos={pontos.length}
                pontos_nunca_usados={pontos_nunca_usados}
            />

            {/* Alterações */}
            <AlteracoesMalha
                variante="sidebar"
                inserirPontos={inserirPontos}
                setInserirPontos={setInserirPontos}
                moverPontos={moverPontos}
                setMoverPontos={setMoverPontos}
            />

            {/* Conteúdo: Controle Lateral */}
            <SidebarContent>
                <ControleLateralModal
                    inserirPontos={inserirPontos}
                    tipo_analise_selecionada={tipo_analise_selecionada}
                    setTipo_analise_selecionada={setTipo_analise_selecionada}
                    cor_selecionada={cor}
                    setCor_selecionada={setCor}
                    setTipo_analise_selecionada_id={setTipo_analise_selecionada_id}
                    selecionarTodos={selecionarTodos}
                    grupoAnalises={grupoAnalises}
                    talhao_area={String(talhao_area)}
                    pontos_totais={pontos.length}
                    pontos={pontos_selecionados}
                    pontos_selecionados_adicionados={pontos_selecionados_adicionados}
                    fake_loading={fake_loading}
                    grupoAnalisesTratado={grupoAnalisesTratado}
                    adicionarPontosSelecionados={adicionarPontosSelecionados}
                    selecionarTodosPontos={selecionarTodosPontos}
                    limparPontosSelecionados={limparPontosSelecionados}
                    deletarPontosSelecionados={deletarPontosSelecionados}
                    pontos_da_malha={pontos}
                    analises_salvas={analises_salvas}
                    selecionarPontosEmMassa={selecionarPontosEmMassa}
                    inverterSelecaoPontos={inverterSelecaoPontos}
                    analises_em_uso={analises_em_uso}
                    analise_destacada={analise_destacada}
                    aoDestacarAnalise={aoDestacarAnalise}
                    isFullscreen // Prop para ajustar layout interno se necessário
                />
            </SidebarContent>

            {/* Footer: Botões */}
            <SidebarFooter>
                <AcaoSalvar
                    salvarPontosSelecionados={salvarPontosSelecionados}
                    total_pontos_selecionados={pontos_selecionados.length}
                    total_analises_adicionadas={pontos_selecionados_adicionados.length}
                    sairDoFullscreen={() => toggleFullscreen()}
                />
            </SidebarFooter>
        </SidebarContainerFullscreen>
    )
}
